import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseSignOutRepository } from '@/modules/auth/infra'
import type { SignOut } from '@/modules/auth/use-cases'

export function makeSignOut(): SignOut {
  return new SupabaseSignOutRepository(makeSupabaseClient()).execute
}
